import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-my-subjects', {
  key: 'admin-my-subjects',
  label: 'My Subjects',
  getSteps: () => [
    introStep({
      title: 'Your Teaching Load',
      content:
        'The subjects assigned to you for the current term, broken down by class. Click a class chip to see its students, "Scores" to enter marks, or "Quick Assessments" to manage assessments and CBT.',
    }),
    step({
      target: '#tour-my-subjects-list',
      title: 'Subject Cards',
      content:
        'Each card is one subject. The chips inside show the classes you teach this subject in — click any chip to drill into that class.',
      placement: 'top',
    }),
  ],
});

registerTourPage('admin-subject-students', {
  key: 'admin-subject-students',
  label: 'Subject Students',
  getSteps: () => [
    step({
      target: '#tour-subject-students-header',
      title: 'Class Roster',
      content:
        'Students enrolled in this subject for the chosen class. The count at the top reflects the full roster after filtering.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-subject-students-grid',
      title: 'Student Cards',
      content:
        'A condensed view of each student — name, matric number, and contact details. Use this to take attendance or sanity-check enrollment.',
      placement: 'top',
    }),
  ],
});

registerTourPage('admin-subject-assessments', {
  key: 'admin-subject-assessments',
  label: 'Subject Assessments',
  getSteps: () => [
    step({
      target: '#tour-subject-assessments-actions',
      title: 'New Assessment or CBT',
      content:
        '"New Assessment" creates a paper assessment (test, project, etc.). "Create CBT" sets up a computer-based test — optionally tied to an assessment so the score flows back automatically.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-subject-assessments-list',
      title: 'Assessments for this Subject',
      content:
        'Each row is one assessment with its max score. Use the row actions to edit it, delete it, or spin up a CBT linked to that assessment.',
      placement: 'top',
    }),
  ],
});

registerTourPage('admin-subject-scores', {
  key: 'admin-subject-scores',
  label: 'Subject Scores',
  getSteps: () => [
    step({
      target: '#tour-subject-scores-term',
      title: 'Pick a Term',
      content:
        'Scores are stored per academic term. Pick the term first — the marks book and upload tools will load for that term.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-subject-scores-tabs',
      title: 'Marks Book vs Upload',
      content:
        'The first tab shows the marks book — one row per student, one column per assessment. The second tab lets you bulk-upload scores from a spreadsheet.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-subject-scores-actions',
      title: 'Download or Upload',
      content:
        'Need a paper copy? "Download Sheet" exports the marks book. Got a spreadsheet from a colleague? "Upload Scores" jumps to the bulk import tab.',
      placement: 'bottom',
    }),
  ],
});

registerTourPage('admin-subject-cbt-create', {
  key: 'admin-subject-cbt-create',
  label: 'Create CBT',
  getSteps: () => [
    introStep({
      title: 'Set Up a CBT',
      content:
        'Configure a computer-based test for this subject. Set title, duration, and content source, then add or import questions. Click "Create Test" up top when you\'re done.',
    }),
  ],
});
